import React, { useContext } from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { useSnackbar } from 'notistack';
import DetailedTable from '../../components/DetailedTable';
import { Button, Typography, Dialog } from '@material-ui/core';
import { DialogForm } from '../../components/DialogForm';
import Trash from '@jda/lui-common-icon-library/ui/Trash';
import Edit from '@jda/lui-common-icon-library/ui/Edit';
import { DELETE_OPERATION, WORKFLOW_LIST } from '../graphQL/queries';
import { testDatacolumns } from './CertificationConfic';
import AddCertification from './AddCertification';
import { StateContext } from '../../App';

type workflowInfo = {
  workflowCode: string;
  workflowName: string;
  operations?: any;
};

type workflowObj = {
  workflow: workflowContentData;
};

type workflowContentData = {
  content: workflowInfo[];
};

const CertificationTestData = (props: any) => {
  const { simulatedService, getOperations } = props;

  const [deleteOperation] = useMutation(DELETE_OPERATION);
  const workflowList = useQuery<workflowObj, {}>(WORKFLOW_LIST, {});
  const { enqueueSnackbar } = useSnackbar();
  const state = useContext(StateContext);
  const initialState = {
    addTestOpen: false,
    isDeleteOpen: false,
    formType: '',
    operation: { testDataName: '', serviceNm: '', operation: '', workflowCode: '', description: '' }
  };

  const [{ addTestOpen, isDeleteOpen, operation, formType }, setFormField] = React.useState({
    ...initialState
  });

  const handleTestconfig = (rowData: any) => {
    if (rowData?.operation && rowData?.serviceNm) {
      const wokrflowObj = workflowList?.data?.workflow?.content?.filter(
        (item: any) => item.workflowName === rowData?.serviceNm
      );
      const oprObj = {
        testDataName: rowData.testDataName,
        description: rowData.description,
        operation: rowData.operation,
        serviceNm: rowData.serviceNm,
        workflowCode: wokrflowObj?.[0]?.workflowCode || ''
      };
      setFormField(prevState => ({
        ...prevState,
        formType: 'edit',
        operation: oprObj
      }));
    } else {
      setFormField(prevState => ({ ...prevState, formType: 'add' }));
    }
    setFormField(prevState => ({ ...prevState, addTestOpen: !addTestOpen }));
  };

  const deleteTestconfig = (rowData: any) => {
    setFormField(prevState => ({ ...prevState, isDeleteOpen: !isDeleteOpen, operation: rowData }));
  };

  const deleteOperationInfo = () => {
    deleteOperation({
      variables: {
        testDataName: operation?.testDataName,
        serviceNm: operation?.serviceNm,
        operation: operation?.operation
      }
    })
      .then((response: any) => {
        enqueueSnackbar('Operation Deleted Successfully !!', {
          variant: 'success',
          preventDuplicate: true
        });
        setFormField(prevState => ({ ...prevState, isDeleteOpen: !isDeleteOpen, initialState }));
        getOperations();
      })
      .catch((error: any) => {
        enqueueSnackbar('Operation Delete failed !!', {
          variant: 'error',
          preventDuplicate: true
        });
      });
  };
  const operationsTableActions: any = [
    //   userRole === 'APP_ADMIN' &&
    {
      icon: () => (
        <Button
          variant="outlined"
          onClick={handleTestconfig}
          data-id="new-operation"
          id="new-operation"
          color="primary"
        >
          Add
        </Button>
      ),
      onClick: () => {},
      // isFreeAction: !isActionOnSelect,
      position: 'toolbar'
    },
    //   userRole !== 'APP_ADMIN' &&
    {
      icon: () => <Edit data-id="edit-operation" id="edit-operation" />,
      onClick: (event: any, rowData: any) => handleTestconfig(rowData)
    },
    {
      icon: () => <Trash data-id="delete-operation" id="delete-operation" />,
      onClick: (event: any, rowData: any) => deleteTestconfig(rowData)
    }
  ];

  const toggleModal = () => {
    setFormField(prevState => ({ ...prevState, addTestOpen: !addTestOpen }));
    getOperations();
  };

  const getTestData = (page: any) => {
    getOperations({
      variables: { search: `page=${page}&size=${state?.userPreferences?.['operationsGrid']?.rowsPerPage}` }
    });
  };

  return (
    <>
      <DetailedTable
        key="operationsInfo"
        id={props.id}
        title="Operations"
        columns={testDatacolumns}
        data={simulatedService?.simulatedData?.content}
        tableActions={operationsTableActions}
        showPagination
        showSpecificPage
        count={simulatedService?.simulatedData?.totalElements}
        rowsPerPage={simulatedService?.simulatedData?.size || 10}
        page={0}
        serverPagination={true}
        getData={getTestData}
        showTopPagination
      />
      <Dialog
        maxWidth="xl"
        fullWidth
        open={addTestOpen}
        onClose={() => setFormField(prevState => ({ ...prevState, addTestOpen: !addTestOpen }))}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id="test-data-modal"
      >
        <AddCertification
          formType={formType}
          operation={operation}
          toggleModal={toggleModal}
          getOperations={getOperations}
          workflowList={workflowList}
        />
      </Dialog>
      <DialogForm
        openFn={isDeleteOpen}
        dataConfig={[]}
        handleDialogClose={() => setFormField(prevState => ({ ...prevState, isDeleteOpen: !isDeleteOpen }))}
        handleDialogSubmit={deleteOperationInfo}
        submitlabel={'Delete'}
        title={`Delete Field`}
        dialogId="delete-field-id"
        closeFn={() => setFormField(prevState => ({ ...prevState, isDeleteOpen: !isDeleteOpen }))}
        maxWidth="sm"
      >
        <Typography color="textPrimary">
          Are you sure want to delete <b>{operation?.testDataName} ?</b>
        </Typography>
      </DialogForm>
    </>
  );
};

export default CertificationTestData;
